import { ServiceBase } from "@app/shared";
import { ContractEntityAffiliationModel } from "./servicing-provider/providerAffiliation";

export default class ProviderAffiliationService extends ServiceBase {

  public GetLatestContractEntitiesByNpi1(practitionerNpi: string): Promise<ContractEntityAffiliationModel[]> {
    const data = this.makeGet<[]>(`/ProviderAffiliation/GetLatestContractEntitiesByNpi1?practitionerNpi1=${practitionerNpi}`);
    return data;
  }
}